import { UserBasic, UserRole } from '@hefe/models';
import { userState } from '@hefe/store';
import { Col, Row, Tabs } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import SwitchRequestsComponent from '../../components/switch-requests/switch-requests.component';

interface UserBasicWithRoles extends UserBasic {
  role: UserRole[];
}

export default function SwitchRequestsPage() {
  const stateUser = useSelector(userState);

  const [activeTab, setActiveTab] = useState(
    stateUser.user?.id?.toString() ?? '0'
  );

  if (!stateUser.user) {
    return null;
  }

  if (stateUser.user.user_settings.show_child_users) {
    const users: UserBasicWithRoles[] = [];
    users.push(stateUser.user as UserBasicWithRoles);
    stateUser.childUsers.forEach((user) => {
      users.push(user);
    });

    return (
      <Row>
        <Col xs={24}>
          <Tabs
            defaultActiveKey={`${users[0].id}`}
            onChange={(activeKey) => setActiveTab(activeKey)}
          >
            {users.map((user) => {
              const username = `${user.firstname} ${user.lastname}`;
              return (
                <Tabs.TabPane key={`${user.id}`} tab={username}>
                  <SwitchRequestsComponent
                    userId={user.id}
                    roles={user.role}
                    active={activeTab === `${user.id}`}
                  />
                </Tabs.TabPane>
              );
            })}
          </Tabs>
        </Col>
      </Row>
    );
  } else {
    return (
      <Row>
        <Col xs={24}>
          <SwitchRequestsComponent
            userId={stateUser.user?.id}
            roles={stateUser.user.role}
            active={activeTab === `${stateUser.user.id}`}
          />
        </Col>
      </Row>
    );
  }
}
